import React, { useState } from "react";
import { Form, Input, Select, Modal, Button, Divider } from "antd";
import { getComponentLabel } from "../../utils/Utils";

export default function LinkUI(props) {
    const {
        value = {},
        onChange = () => { },
        onBlur = () => { },
        form_item = true,
        anchor = false,
        items = [],
    } = props;

    let _p = "/";
    let _value = value;

    const strip = (_v) => {
        if (_v?.substr(0, 7) === "mailto:") {
            _p = "mailto:";
            _v = _v.substr(7);
        }
        if (_v?.substr(0, 8) === "https://") {
            _p = "https://";
            _v = _v.substr(8);
        }
        if (_v?.substr(0, 7) === "http://") {
            _p = "http://";
            _v = _v.substr(7);
        }
        if (_v?.substr(0, 1) === "/") {
            _p = "/";
            _v = _v.substr(1);
        }
        if (_v?.substr(0, 7) === "anchor:") {
            _p = "Scroll";
            _v = _v.substr(7);
        }
        return _v;
    };

    _value = strip(_value);

    const [v, setV] = useState(_value);
    const [protocol, setProtocol] = useState(_p);
    const [anchorModal, setAnchorModal] = useState(false);

    const openAnchorModal = () => setAnchorModal(true);
    const closeAnchorModal = () => setAnchorModal(false);

    const handleAnchorSelect = (id) => {
        setAnchorModal(false);
        setProtocol("Scroll");
        setV(id);
        onChange("anchor:" + id);
        onBlur("anchor:" + id);
    };

    const selectProtocol = (
        <Select
            onChange={(e) => {
                if (e === "Scroll") {
                    openAnchorModal();
                } else {
                    setProtocol(e);
                    onChange(e + strip(value));
                    onBlur(e + strip(value));
                }
            }}
            style={{ width: "90px" }}
            value={protocol}
            className="select-before"
        >
            <Select.Option value="https://">
                <small>https://</small>
            </Select.Option>
            <Select.Option value="http://">
                <small>http://</small>
            </Select.Option>
            <Select.Option value="mailto:">
                <small>mailto:</small>
            </Select.Option>
            <Select.Option value="/">
                <small>/</small>
            </Select.Option>
            {anchor && (
                <Select.Option value="Scroll">
                    <small>Scroll</small>
                </Select.Option>
            )}
        </Select>
    );

    return (
        <div>
            {form_item && (
                <Form.Item initialValue={_value} noStyle hidden name="url">
                    <Input hidden />
                </Form.Item>
            )}

            <Input
                value={v}
                className="input-fs"
                addonBefore={selectProtocol}
                onClick={() => {
                    if (protocol === "Scroll") {
                        openAnchorModal();
                    }
                }}
                onBlur={(e) => {
                    if (protocol !== "Scroll") {
                        setV(strip(e.target.value));
                        onBlur(protocol + strip(e.target.value));
                    }
                }}
                onChange={(e) => {
                    if (protocol !== "Scroll") {
                        setV(strip(e.target.value));
                        onChange(protocol + strip(e.target.value));
                    }
                }}
                style={{ width: "100%", fontSize: "11px" }}
                placeholder="URL..."
                readOnly={protocol === "Scroll"} // prevents typing if anchor
            />

            {/* Anchor Picker Modal */}
            <Modal
                title="Select Component"
                open={anchorModal}
                width={400}
                onCancel={closeAnchorModal}
                footer={null}
            >
                <p style={{"opacity" : "0.8"}}>Choose a component from the list. Clicking the button will scroll to the selected component on this page.</p>
                <div style={{ "maxHeight": "500px", "overflow": "auto", "paddingRight" : "5px" }}>
                    {items.map(item => {
                        // return(<><pre>{JSON.stringify(item, null, 2)}</pre></>)
                        return (<div size="small" block onClick={() => handleAnchorSelect(item.ee_id)}>

                            <Button block style={{ "textAlign": "left" }}><a>{(item.name) ? item.name : "unnamed"}</a>&nbsp;<em><small style={{ "opacity": "0.6" }}>({getComponentLabel(item.component)})</small></em></Button>
                            <Divider style={{ "margin": "5px 0px" }} dashed />
                        </div>)
                    })}
                </div>
            </Modal>
        </div>
    );
}
